export default "__VITE_ASSET__6282b377__"